import {useMemo} from "react";

import {Rule} from "../model/types";
import {filterRules} from "../model/filterRules";

type UseFilteredRulesProps = {
  rules: Rule[];
  searchTerm: string;
};

export const useFilteredRules = ({rules, searchTerm}: UseFilteredRulesProps) => {
  const filteredRules = useMemo(() => {
    return filterRules({rules, searchTerm});
  }, [rules, searchTerm]);

  return {
    filteredRules,
  };
};
